/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TeamFormationRole } from './TeamFormationRole';
import {
    TeamFormationRoleFromJSON,
    TeamFormationRoleFromJSONTyped,
    TeamFormationRoleToJSON,
    TeamFormationRoleToJSONTyped,
} from './TeamFormationRole';

/**
 * Team member with populated user data
 * @export
 * @interface ITeamMemberResponse
 */
export interface ITeamMemberResponse {
    /**
     * 
     * @type {string}
     * @memberof ITeamMemberResponse
     */
    odId: string;
    /**
     * 
     * @type {string}
     * @memberof ITeamMemberResponse
     */
    displayName: string;
    /**
     * 
     * @type {TeamFormationRole}
     * @memberof ITeamMemberResponse
     */
    role: TeamFormationRole;
    /**
     * 
     * @type {number}
     * @memberof ITeamMemberResponse
     */
    joinedAt: number;
    /**
     * 
     * @type {boolean}
     * @memberof ITeamMemberResponse
     */
    confirmed: boolean;
    /**
     * 
     * @type {number}
     * @memberof ITeamMemberResponse
     */
    confirmedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof ITeamMemberResponse
     */
    avatarUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ITeamMemberResponse
     */
    isOnline?: boolean;
}



/**
 * Check if a given object implements the ITeamMemberResponse interface.
 */
export function instanceOfITeamMemberResponse(value: object): value is ITeamMemberResponse {
    if (!('odId' in value) || value['odId'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('joinedAt' in value) || value['joinedAt'] === undefined) return false;
    if (!('confirmed' in value) || value['confirmed'] === undefined) return false;
    return true;
}

export function ITeamMemberResponseFromJSON(json: any): ITeamMemberResponse {
    return ITeamMemberResponseFromJSONTyped(json, false);
}

export function ITeamMemberResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITeamMemberResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'odId': json['odId'],
        'displayName': json['displayName'],
        'role': TeamFormationRoleFromJSON(json['role']),
        'joinedAt': json['joinedAt'],
        'confirmed': json['confirmed'],
        'confirmedAt': json['confirmedAt'] == null ? undefined : json['confirmedAt'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'isOnline': json['isOnline'] == null ? undefined : json['isOnline'],
    };
}

export function ITeamMemberResponseToJSON(json: any): ITeamMemberResponse {
    return ITeamMemberResponseToJSONTyped(json, false);
}

export function ITeamMemberResponseToJSONTyped(value?: ITeamMemberResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'odId': value['odId'],
        'displayName': value['displayName'],
        'role': TeamFormationRoleToJSON(value['role']),
        'joinedAt': value['joinedAt'],
        'confirmed': value['confirmed'],
        'confirmedAt': value['confirmedAt'],
        'avatarUrl': value['avatarUrl'],
        'isOnline': value['isOnline'],
    };
}

